<template>
  <a-row :gutter="20">
    <a-col :span="18">
      声纹加密功能暂未实现......
    </a-col>
    <a-col :span="6">
    </a-col>
  </a-row>
</template>

<script>
  export default {
    name: 'Item1',
    components: {  }
  }
</script>

<style scoped>

</style>